import React from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';


import '../List/List';

type Props = {
  component: string,
  showMap: boolean,
  setShowMap: (showMap: boolean) => void
}

const CustomButton: React.FunctionComponent<Props> = (prop: Props) => {
  const showMap = prop.showMap;
  const component = prop.component;
  const setShowMap = prop.setShowMap;
  const { t } = useTranslation();

  function handler() {
    if (component === "map") {
      return setShowMap(true);
    } else {
      return setShowMap(false);
    }
  }

  const getButtonClassName = () => {
    if (component === 'map') {
      return showMap ? 'active' : 'inactive';
    }
    else if (component === 'list') {
      return showMap ? 'inactive' : 'active';
    }
  }

  const componentName = () => {
    if (component === 'map') {
      return t('mapList:component.map');
    }
    else if (component === 'list') { 
      return t('mapList:component.list');
    }
  }

  const helpText = () => {
    if (component === 'map') {
      return t('mapList:component.helpTextMap');
    }
    else if (component === 'list') { 
      return t('mapList:component.helpTextList');
    }
  }

  return (
    <button className={`button--react-${component} ${getButtonClassName()}`} onClick={handler}>
      <label hidden>{helpText()}</label>
      {componentName()}
    </button>
  )
}

export default CustomButton;